/**
 * 글쓴이 본문 — **우리 CSS 를 태우지 않는다**(2026-09-01 사용자 최우선 지시).
 *
 * 서버가 sanitize 한 값이라 그대로 그린다(`docs/프론트_공용셋.md` §7). 격리는 CSS 가 한다 —
 * `web.css` 의 `.board-content * { all: revert }` 가 가이드 전역 리셋을 걷고 브라우저
 * 기본값으로 되돌린다. 글쓴이가 쓴 인라인 스타일은 작성자 규칙보다 세므로 그대로 이긴다.
 *
 * 그래서 **여기서 글자 크기·색·간격을 정하지 않는다.** 바깥 상자(가이드 `board-view-content`
 * 등)가 자리를 잡고, 안쪽은 글쓴이 것이다. 새 규칙을 여기에 더하면 그 순간 격리가 깨진다.
 *
 * 서버 컴포넌트다 — 상태가 없다.
 */
export function BoardContent({ html, className }: { html: string | null | undefined; className?: string }) {
  return (
    <div className={className ? `${className} board-content` : 'board-content'}
      dangerouslySetInnerHTML={{ __html: html ?? '' }} />
  );
}
